var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "n-accordion" }, [
    _c(
      "div",
      {
        staticClass: "n-accordion--header",
        class: _vm.readonly && "disabled",
        on: { click: _vm.onOpenAccordion }
      },
      [
        _c("div", { staticClass: "toggle-icon", class: _vm.isOpen && "open" }, [
          _c("a", [
            !_vm.readonly
              ? _c("i", { staticClass: "fo fo-arrow-down" })
              : _vm._e()
          ])
        ]),
        _vm._t("header")
      ],
      2
    ),
    !_vm.readonly
      ? _c(
          "div",
          { staticClass: "n-accordion--content", class: _vm.isOpen && "open" },
          [_vm._t("content")],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51140015", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51140015","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/n-accordion.vue
// module id = uHMY
// module chunks = 0